import { Component, OnDestroy, Input, TemplateRef, ContentChild } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';



@Component({
    selector: 'btn-cell-renderer-save',
    template: `
	<em *ngIf="show_unassign">
	<img style="padding-right:16px;color-red" src="./assets/images/ban-solid.svg" 
	(click)="btnClickedHandler($event,'unassign')" style="cursor:pointer;"> 
	</em>
	`,
    standalone: false
})
export class BtnCellRendererUnAssign implements ICellRendererAngularComp, OnDestroy {



	refresh(params: ICellRendererParams): boolean {
		throw new Error(`Error while refreshing renderer component. INFO-${params}`);
	}

	private params: any;
	pageName;
	show_unassign: boolean = false;

	agInit(params: any): void {
		this.params = params;
		this.pageName = this.params.colDef.field;
		if (this.params.data.roundComplete == 1) {  // NOSONAR
			this.show_unassign = false;
		}
		if ((this.params.data.statusId == 2) || (this.params.data.statusId == 3)) {  // NOSONAR
			this.show_unassign = true;
		}
		else
			{this.show_unassign = false;}
	}

	btnClickedHandler(_event, action) {
		if (action == 'unassign') {  // NOSONAR
			this.params.context.componentParent.usAssign(this.params.data.kpiId, this.params.data.userId, this.params.data.route);
		}
	}

	ngOnDestroy() {
console.info()


	}
}
